import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
var AjaxFormModule = require('../../modules/ajaxForm');

var Page = {
    alias: 'login',
    selectors: {
        form: '#loginForm'
    },

    init: function () {
        Page.onFormSubmit()

        tippy('[data-tippy-content]', {
            placement: 'top',
            theme: 'light',
            arrow: true,
            animation: 'fade',
            interactive: false,
            allowHTML: false,
            appendTo: document.body,
        });
    },

    onFormSubmit: function () {
        $(document).on('submit', Page.selectors.form, function (e) {
            e.preventDefault();

            var form = $(this);
            var validator = AjaxFormModule.validate(form, AjaxFormModule.validationRules.auth.login);
            if (form.valid()) {
                AjaxFormModule.submit(form, function(response) {
                    window.location.reload();
                });
            }
        })
    }
}

Page.init()
